import axios from 'axios'

/**
 * 第三方站点提供的澳门历史开奖接口（完整 URL，按自然年）。
 * https://history.macaumarksix.com/history/macaujc2/y/${year}
 *
 * 默认直接请求上述域名。若浏览器报 CORS，可在项目根目录 `.env.development` 中设置：
 *   VUE_APP_MACAU_HISTORY_USE_PROXY=true
 * 并保留 vue.config.js 里 `/macau-history` 代理，此时会走本地代理转发。
 */
const MACAU_HISTORY_ORIGIN = 'https://history.macaumarksix.com'

const client = axios.create({
  timeout: 25000,
  headers: { Accept: 'application/json' }
})

function macauHistoryYearUrl(year) {
  const y = Number(year)
  const path = `/history/macaujc2/y/${y}`
  const useProxy =
    typeof process !== 'undefined' &&
    process.env &&
    process.env.VUE_APP_MACAU_HISTORY_USE_PROXY === 'true'
  if (useProxy) {
    return `/macau-history${path}`
  }
  return `${MACAU_HISTORY_ORIGIN}${path}`
}

export function fetchMacauHistoryYear(year) {
  return client.get(macauHistoryYearUrl(year))
}
